import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { HStack } from '../hstack'
import { Pressable } from '../pressable'
import { Text } from '../text'
import { VStack } from '../vstack'

export type ReportCardProps = {
    title: string
    supportingText?: string
    icon: React.ReactNode
    onPress?: () => void
    className?: string
    testID?: string
}

export const ReportCard: React.FC<ReportCardProps> = ({
    title,
    supportingText,
    icon,
    onPress,
    className,
    testID,
}) => {
    const body = (
        <HStack className='w-full items-start gap-4'>
            <Box className='size-10 items-center justify-center rounded-full border border-solid border-content-default'>
                {icon}
            </Box>
            <VStack className='min-w-0 flex-1 gap-2'>
                <Text size='body' weight='semiBold' tone='default'>
                    {title}
                </Text>
                {supportingText ? (
                    <Text size='caption' tone='muted'>
                        {supportingText}
                    </Text>
                ) : null}
            </VStack>
        </HStack>
    )

    const surface = twMerge('w-full rounded bg-background-elevation p-4', className)

    if (!onPress) {
        return (
            <Box testID={testID} className={surface}>
                {body}
            </Box>
        )
    }
    return (
        <Pressable
            testID={testID}
            onPress={onPress}
            accessibilityRole='button'
            className={twMerge(surface, 'hover:bg-background-surface-hover')}
        >
            {body}
        </Pressable>
    )
}
ReportCard.displayName = 'ReportCard'
